<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="params" label-width="77px" class="ele-form-search" @keyup.enter.native="searchChart" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="5" :sm="12">
            <el-form-item label="日期:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleDateChange"
                clearable
                style="width: 270px"
              />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="校部:">
              <el-select v-model="params.branchId" placeholder="请选择校部" clearable @change="handleBranchChange">
                <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="年级:">
              <el-select v-model="params.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="班级:">
              <el-select v-model="params.classId" placeholder="请选择班级" clearable @change="handleClassChange">
                <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchChart" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button type="primary" @click="exportData" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="analysis-chart-card-content">
        <ele-chart ref="charts" :option="option1" style="height: 500px" />
      </div>
    </el-card>
  </div>
</template>

<script>
  import EleChart from '@/components/EleChart';
  import { accessStatisticsChart, selectionList, accessStatisticsChartExport } from '@/config/yizhongDong/examine';
  export default {
    name: 'SimpleClass',
    components: { EleChart },
    data() {
      return {
        params: {
          startTime: '',
          endTime: '',
          branchId: undefined,
          gradeId: undefined,
          classId: undefined,
        },
        date: null,
        branchList: [],
        gradeList: [],
        classList: [],
        className: '',
        chartData: undefined,
      };
    },
    computed: {
      option1() {
        return {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            orient: 'horizontal',
            left: 'center',
            bottom: 0,
          },
          series: [
            {
              name: this.className,
              type: 'pie',
              radius: '40%',
              center: ['50%', '40%'],
              data: this.chartData,
              label: {
                show: true,
                formatter: '{b}: {c} ({d}%)',
              },
            },
          ],
        };
      },
    },
    created() {
      // 初始化加载校部列表
      this.loadBranchList();
    },
    methods: {
      // 加载校部列表
      async loadBranchList() {
        try {
          const res = await selectionList({ type: 1, projectType: 2 });
          if (res.data.resCode == 200) {
            this.branchList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载校部列表失败:', error);
        }
      },
      // 加载年级列表
      async loadGradeList(branchId) {
        if (!branchId) {
          this.gradeList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 2, projectType: 2, id: branchId });
          if (res.data.resCode == 200) {
            this.gradeList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载年级列表失败:', error);
        }
      },
      // 加载班级列表
      async loadClassList(gradeId) {
        if (!gradeId) {
          this.classList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 4, projectType: 2, id: gradeId });
          if (res.data.resCode == 200) {
            this.classList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载班级列表失败:', error);
        }
      },
      // 选择校部时
      handleBranchChange(branchId) {
        // 清空下级选项
        this.params.gradeId = undefined;
        this.params.classId = undefined;
        this.gradeList = [];
        this.classList = [];

        // 加载年级列表
        if (branchId) {
          this.loadGradeList(branchId);
        }
      },
      // 选择年级时
      handleGradeChange(gradeId) {
        // 清空下级选项
        this.params.classId = undefined;
        this.classList = [];
        // 加载班级列表
        if (gradeId) {
          this.loadClassList(gradeId);
        }
      },
      // 选择班级时
      handleClassChange(classId) {
        this.className = this.classList.find((item) => item.id == classId).name;
      },
      // 重置表单
      handleReset() {
        this.params = {};
        this.date = null;
        this.gradeList = [];
        this.classList = [];
        this.$refs.table.reload();
      },
      // 选择时间
      handleDateChange(value) {
        this.params.startTime = value[0];
        this.params.endTime = value[1];
      },
      // 查询数据
      searchChart() {
        if (!this.params.classId) return this.$message.error('请选择到班级');
        accessStatisticsChart(this.params).then((res) => {
          if (res.data.resCode == 200) {
            this.chartData = res.data.data;
            this.$refs.charts.init();
            this.$refs.charts.resize();
          }
        });
      },
      // 导出数据
      exportData() {
        accessStatisticsChartExport(this.params).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
